import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { TradingSymbols } from '@monorepo/client-types';
import { Flex, Statistic, TextComponent } from '@monorepo/react-components';

interface Props {
  baseBalance: number;
  pnl: number;
  invalidPnl: number;
  credits: number;
  withdrawalAmount: number;
  testId?: string;
}

export const AccountBalanceTooltipContent: FunctionComponent<Props> = ({
  baseBalance,
  pnl,
  invalidPnl,
  credits,
  testId,
  withdrawalAmount,
}) => {
  const { t } = useTranslation(['dashboardTemplates']);

  const CREDITS_LABEL = t('dashboardTemplates:credits');
  const INVALID_LABEL = t('dashboardTemplates:invalid_trades');
  const PNL_LABEL = t('dashboardTemplates:pnl');
  const BASE_BALANCE_LABEL = t('dashboardTemplates:base_balance');
  const PAYOUT_AMOUNT_LABEL = t('dashboardTemplates:payouts');

  return (
    <Flex gap={8} vertical={true} data-testid={testId}>
      <TextComponent level={7}>
        <Statistic
          value={baseBalance}
          prefix={'$'}
          suffix={<TextComponent>&nbsp; ({BASE_BALANCE_LABEL})</TextComponent>}
          precision={2}
        />
        {pnl >= 0 ? TradingSymbols.PLUS : TradingSymbols.MINUS}
        <Statistic
          value={Math.abs(pnl)}
          prefix={'$'}
          suffix={<TextComponent>&nbsp; ({PNL_LABEL})</TextComponent>}
          precision={2}
        />
        {TradingSymbols.PLUS}
        <Statistic
          value={Math.abs(credits)}
          prefix={'$'}
          precision={2}
          suffix={<TextComponent>&nbsp; ({CREDITS_LABEL})</TextComponent>}
        />
        {TradingSymbols.MINUS}
        <Statistic
          value={Math.abs(invalidPnl)}
          prefix={'$'}
          suffix={<TextComponent>&nbsp; ({INVALID_LABEL})</TextComponent>}
          precision={2}
        />
        {withdrawalAmount > 0 && (
          <>
            {TradingSymbols.MINUS}
            <Statistic
              value={withdrawalAmount}
              prefix={'$'}
              suffix={
                <TextComponent>&nbsp; ({PAYOUT_AMOUNT_LABEL})</TextComponent>
              }
              precision={2}
            />
          </>
        )}
      </TextComponent>
    </Flex>
  );
};
